import React from 'react'
import { Grid, Col, Divider, Join, Space } from '@gousto-internal/citrus-react'
import { SectionWrapper } from './components/SectionWrapper'
import { AccountDetailsHeader } from './components/AccountDetailsHeader'
import { ResetPasswordSection } from './components/ResetPasswordSection'
import { UserNameSection } from './components/UserNameSection'
import { PhoneNumberSection } from './components/PhoneNumberSection'
import { AccountBalance } from './components/AccountBalance'
import { UserEmailSection } from './components/UserEmailSection'
import { CommunicationPreferencesSection } from './components/CommunicationPreferencesSection'

const VERTICAL_GAP = 6

function AccountDetails() {
  return (
    <Grid gap={[VERTICAL_GAP, 8]} paddingV={[4, 8]} paddingH={[0, 3]}>
      <Col size={12}>
        <AccountDetailsHeader />
      </Col>
      <Col size={[12, 6]}>
        <SectionWrapper id="personalDetails" title="My personal details">
          <Space size={6} direction="vertical" />
          <Join with={<Space size={6} />}>
            <UserNameSection />
            <PhoneNumberSection />
            <UserEmailSection />
            <Divider />
            <ResetPasswordSection />
          </Join>
        </SectionWrapper>
        <Space size={VERTICAL_GAP} />
        <SectionWrapper id="communicationPreferences" title="Communication preferences">
          <CommunicationPreferencesSection />
        </SectionWrapper>
      </Col>
      <Col size={[12, 6]}>
        <SectionWrapper id="accountBalance" title="Account balance">
          <Space size={2} direction="vertical" />
          <AccountBalance />
        </SectionWrapper>
      </Col>
    </Grid>
  )
}

export { AccountDetails }
